// Google reCAPTCHA v3 — env-gated. If REACT_APP_RECAPTCHA_SITE_KEY is not set
// the module is inert and getRecaptchaToken() resolves to an empty string, so
// existing honeypot + dwell heuristics carry the load without any UI change.
//
// The script is lazy-loaded on first call (not at page load) so it never blocks
// initial paint and never fires on pages that don't have a form.

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";

let loadPromise = null;

function loadScript() {
  if (!SITE_KEY) return Promise.resolve(false);
  if (loadPromise) return loadPromise;
  loadPromise = new Promise((resolve) => {
    if (typeof window === "undefined") return resolve(false);
    if (window.grecaptcha && window.grecaptcha.execute) return resolve(true);
    const s = document.createElement("script");
    s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(SITE_KEY)}`;
    s.async = true;
    s.defer = true;
    s.onload = () => {
      if (window.grecaptcha && window.grecaptcha.ready) {
        window.grecaptcha.ready(() => resolve(true));
      } else {
        resolve(true);
      }
    };
    s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });
  return loadPromise;
}

export async function getRecaptchaToken(action = "lead_submit") {
  if (!SITE_KEY) return "";
  try {
    const ready = await loadScript();
    if (!ready || !window.grecaptcha || !window.grecaptcha.execute) return "";
    return await window.grecaptcha.execute(SITE_KEY, { action });
  } catch (_e) {
    return "";
  }
}

export const RECAPTCHA_ENABLED = Boolean(SITE_KEY);
